export const AutoLogoutTypes = {
    FORCE: 'force',
    INACTIVITY: 'inactivity',
};
